/* eslint-disable @nx/enforce-module-boundaries */
import { useEffect, useState, useContext } from 'react';
import {
  Card,
  Stack,
  Tabs,
  TabList,
  Tab,
  Heading,
  Button,
  HStack,
  Spinner,
  Text,
  useDisclosure,
} from '@mybridge/ui';
import { MyProfileContext } from 'v4/components/profile/context';
import {
  EarthGlobeIcon,
  EditIcon,
  OnlyMeLockIcon,
  TeamIcon,
} from '@mybridge/icons';
import styles from './photos.module.scss';
import InfiniteScroll from 'react-infinite-scroll-component';
import { CreateAudiencePermissionModal } from 'v4/components/profile/audience-modal-create';
import { Link } from '@mybridge/ui/link';
import PhotoActionsMenu from 'v4/components/profile/photo-actions-menu';
import _ from 'lodash';
import DashboardReelModal from 'v4/components/ReelModal/DashboardReelModal';
import ImageModal from 'v4/components/imageModal/ImageModal';
import { DashboardPostForm } from 'v4/snippets/dashboard/post-form';
import { MyProfileCreatePostModal } from 'v4/components/profile/create-post-modal';
import { isMobile } from 'react-device-detect';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const MyProfilePhotos = () => {
  const {
    userProfileInfo,
    aggregatedPhotosData,
    refetchAgregatedPhotos,
    photosOfYouCount,
    hasPhotosOfYou,
    photosOfYou,
    refetchPhotosOfyou,
    photosOfYouHasNextPage,
    photosOfYouFetchNextPage,
    yourPhotos,
    yourPhotosCount,
    hasYourPhotos,
    refetchYourPhotos,
    yourPhotosHasNextPage,
    yourPhotosFetchNextPage,
    coverPhotos,
    hasCoverPhotos,
    coverPhotoCount,
    refetchCoverPhotos,
    coverPhotosHasNextPage,
    coverPhotosFetchNextPage,
    profilePhotos,
    hasProfilePhotos,
    profilePhotoCount,
    refetchProfilePhotos,
    profilePhotosHasNextPage,
    profilePhotosFetchNextPage,
    yourVideos,
    hasYourVideos,
    yourVideosCount,
    refetchyourVideos,
    yourVideosHasNextPage,
    yourVideosFetchNextPage,
    videosOfYou,
    hasVideosOfYou,
    videosOfYouCount,
    refetchvideosOfYou,
    videosOfYouHasNextPage,
    videosOfYouFetchNextPage,
  } = useContext(MyProfileContext);
  const { t } = useTranslator();

  const introValue = _.get(userProfileInfo, 'field_audience.media_photos');
  const [activeTab, setActiveTab] = useState(0);
  const [isAggregatedCards, setIsAggregatedCards] = useState(false);
  const [aggregtedTabIndex, setAggregatedTabIndex] = useState(null);
  const [aggregatedTabs, setAggregatedTabs] = useState([]);
  const audienceCreateDisc = useDisclosure();
  const activityDisc = useDisclosure();
  const [audienceValue, setAudienceValue] = useState(introValue);
  const [activeVideoTab, setActiveVideoTab] = useState(1);
  const [isPostModalOpen, setIsPostModalOpen] = useState(false);

  const [aggregatedData, setAggregatedData] = useState(null);

  const [reelModel, setReelModel] = useState(false);
  const [reelModelProps, setReelModelProps] = useState({
    postsData: [],
    onClose: () => {},
    fetchNext: () => {},
    hasMore: true,
    postIndex: 0,
    postMediaIndex: 0,
  });

  const [imageModel, setImageModel] = useState(false);
  const [imageModelProps, setImageModelProps] = useState({
    postsData: [],
    onClose: () => {},
    fetchNext: () => {},
    hasMore: true,
    postIndex: 0,
    postMediaIndex: 0,
  });

  useEffect(() => {
    setAggregatedData(aggregatedPhotosData);
    if (aggregatedPhotosData) {
      setAggregatedTabs(Object.keys(aggregatedPhotosData));
    }
  }, [aggregatedPhotosData]);

  useEffect(() => {
    if (userProfileInfo) {
      if (aggregtedTabIndex === 'cover') {
        refetchCoverPhotos?.();
      } else if (aggregtedTabIndex === 'profile') {
        refetchProfilePhotos?.();
      } else if (aggregtedTabIndex === 'others') {
        refetchYourPhotos?.({ user: userProfileInfo.slug });
      } else if (aggregtedTabIndex === 'tagged') {
        refetchPhotosOfyou?.({ slug: userProfileInfo.slug });
      } else {
        refetchAgregatedPhotos?.({ user: userProfileInfo.slug, company: '1' });
        refetchPhotosOfyou?.({ slug: userProfileInfo.slug });
        refetchYourPhotos?.({ user: userProfileInfo.slug });
        refetchyourVideos?.({ user: userProfileInfo.slug });
        refetchvideosOfYou?.({ user: userProfileInfo.slug });
      }
    }
  }, [aggregtedTabIndex, userProfileInfo]);

  const refetchPhotos = () => {
    setIsPostModalOpen(false);
    refetchAgregatedPhotos?.({ user: userProfileInfo.slug });
    refetchPhotosOfyou?.({ slug: userProfileInfo.slug });
    refetchYourPhotos?.({ user: userProfileInfo.slug });
    refetchyourVideos?.({ user: userProfileInfo.slug });
    refetchvideosOfYou?.({ user: userProfileInfo.slug });
  };

  const PhotosTabsArray = [
    {
      title: t('profilePhotosVideos.photosOfYou') || 'Photos of you',
    },
    {
      title: t('profilePhotosVideos.yourPhotos') || 'Your Photos',
    },
  ];
  const VideosTabsArray = [
    {
      title: t('profilePhotosVideos.videosOfYou') || 'Videos of you',
    },
    {
      title: t('profilePhotosVideos.yourVideos') || 'Your videos',
    },
  ];

  const renderPermissionSwitch = (param) => {
    switch (param) {
      case 1:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: t('profileDetails.public') || 'Public',
        };
      case 2:
        return {
          icon: <TeamIcon width="16px" height="16px" />,
          text: t('profileDetails.myNetwork') || 'myNetwork',
        };
      case 3:
        return {
          icon: <OnlyMeLockIcon width="16px" height="16px" />,
          text: t('profileDetails.onlyMe') || 'Only me',
        };
      default:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: t('profileDetails.public') || 'Public',
        };
    }
  };

  const aggregatedCardKeys = {
    cover: t('profilePhotosVideos.coverPhotos') || 'Cover photos',
    profile: t('profilePhotosVideos.profilePictures') || 'Profile pictures',
    tagged: t('profilePhotosVideos.tagged') || 'Tagged',
    others: t('profilePhotosVideos.others') || 'Others',
  };

  return (
    <>
      {!isAggregatedCards && (
        <>
          <Card variant="thinBorderedCard" mb={6} p={4}>
            <Stack>
              <Tabs
                orientation="vertical"
                variant="verticalVariantAboutUs"
                justifyContent="space-between"
                mb={6.5}
              >
                <TabList p={0}>
                  <Heading
                    fontSize="20px"
                    color="brandPrimary.500"
                    mb={3}
                    fontWeight="400"
                  >
                    {t('profilePhotosVideos.photos') || 'Photos'}
                    <Button
                      ml={6}
                      ph="10px"
                      borderRadius="50px"
                      leftIcon={renderPermissionSwitch(introValue)?.icon}
                      type="button"
                      onClick={() => {
                        audienceCreateDisc.onOpen();
                      }}
                    >
                      {renderPermissionSwitch(introValue)?.text}
                    </Button>
                  </Heading>
                </TabList>
                <Heading
                  fontSize="17px"
                  color="brandPrimary.500"
                  mb={3}
                  fontWeight="400"
                  className={styles.addMedia}
                  onClick={() => setIsPostModalOpen(true)}
                >
                  {t('profilePhotosVideos.addPhotoVideo') || 'Add photo/video'}
                </Heading>
              </Tabs>
              {isPostModalOpen && (
                <DashboardPostForm
                onCreateSuccess={(e, isVideo) => {
                  if (!!isVideo) {
                    setTimeout(() => {
                      refetchPhotos();
                    }, 25000);
                  } else {
                    refetchPhotos();
                  }
                }}
                  onClose={() => setIsPostModalOpen(false)}
                  isFromProfile={true}
                  fromProfilePhotoVideo={true}
                />
              )}

              <div className={styles.imgCont1}>
                {aggregatedData &&
                  Object.keys(aggregatedData).map((key, index) => {
                    if (aggregatedData[key].count > 0) {
                      return (
                        <div
                          className={isMobile? styles.cardMobile1 :  styles.card1}
                          key={index}
                          onClick={() => {
                            // setIsAggregatedCards(true);
                            // setAggregatedTabIndex(key);
                            if (key === 'others') {
                              setActiveTab(1);
                            } else {
                              setIsAggregatedCards(true);
                              setAggregatedTabIndex(key);
                            }
                          }}
                        >
                          <div>
                            <img
                              src={aggregatedData[key].thumbnail}
                              alt="sample image"
                              className={isMobile ? styles.imgMobile1: styles.img1}
                            />
                          </div>
                          <div className={styles.txtCont1}>
                            {aggregatedCardKeys[key]}
                          </div>
                          <div className={styles.txtCont2}>
                            {aggregatedData[key].count} {t('profilePhotosVideos.items') || 'items'}
                          </div>
                        </div>
                      );
                    } else {
                      return null;
                    }
                  })}
              </div>
            </Stack>
            <Stack minH="300px">
              <Tabs index={activeTab} mb="24px">
                <TabList borderBottomColor="transparent">
                  {PhotosTabsArray.map((t, index) => (
                    <div key={index} onClick={() => setActiveTab(index)}>
                      <Tab>{t?.title}</Tab>
                    </div>
                  ))}
                </TabList>
              </Tabs>
              {activeTab === 0 && (
                <CustomInfiniteScroll
                  isActiveIndex={activeTab}
                  dataLength={photosOfYouCount}
                  next={photosOfYouFetchNextPage}
                  hasMore={photosOfYouHasNextPage}
                  isPhotos={hasPhotosOfYou}
                  photosArray={photosOfYou}
                  setImageModel={setImageModel}
                  setImageModelProps={setImageModelProps}
                />
              )}
              {activeTab === 1 && (
                <CustomInfiniteScroll
                  isActiveIndex={activeTab}
                  dataLength={yourPhotosCount}
                  next={yourPhotosFetchNextPage}
                  hasMore={yourPhotosHasNextPage}
                  isPhotos={hasYourPhotos}
                  photosArray={yourPhotos}
                  setImageModel={setImageModel}
                  setImageModelProps={setImageModelProps}
                />
              )}
            </Stack>
          </Card>

          <Card variant="thinBorderedCard" mb={6} p={4} minH="300px">
            <div className={styles.headerCont2}>
              <div className={styles.heading1}>{t('profilePhotosVideos.videos') || 'Videos'}</div>
              <div className={styles.linkText}>
                <Link href="/profile/videos">{t('profilePhotosVideos.seeAll') || 'See all'}</Link>
              </div>
            </div>
            <Tabs index={activeVideoTab} mb={6}>
              <TabList borderBottomColor="transparent">
                {VideosTabsArray.map((t, index) => (
                  <div key={index} onClick={() => setActiveVideoTab(index)}>
                    <Tab>{t?.title}</Tab>
                  </div>
                ))}
              </TabList>
            </Tabs>
            {activeVideoTab === 0 && (
              <CustomInfiniteVideoScroll
                isActiveIndex={activeVideoTab}
                dataLength={videosOfYouCount}
                next={videosOfYouFetchNextPage}
                hasMore={videosOfYouHasNextPage}
                isVideos={hasVideosOfYou}
                videosArray={videosOfYou}
                setReelModel={setReelModel}
                setReelModelProps={setReelModelProps}
              />
            )}
            {activeVideoTab === 1 && (
              <CustomInfiniteVideoScroll
                isActiveIndex={activeVideoTab}
                dataLength={yourVideosCount}
                next={yourVideosFetchNextPage}
                hasMore={yourVideosHasNextPage}
                isVideos={hasYourVideos}
                videosArray={yourVideos}
                setReelModel={setReelModel}
                setReelModelProps={setReelModelProps}
              />
            )}
          </Card>
        </>
      )}

      {reelModel && <DashboardReelModal {...reelModelProps} />}

      {imageModel && <ImageModal {...imageModelProps} />}

      {isAggregatedCards && (
        <>
          <Card variant="thinBorderedCard" mb={2.5} p={4}>
            <div
              className={styles.headerCont1}
              onClick={() => {
                setAggregatedTabIndex(null);
                setIsAggregatedCards(false);
              }}
            >
              <p className={styles.heading1}>{aggregatedCardKeys[aggregtedTabIndex]}</p>
              <p className={styles.para1}>
                {aggregatedData?.[aggregtedTabIndex]?.count}&nbsp;{t('profilePhotosVideos.items') || 'items'}
              </p>
            </div>
          </Card>

          <Card variant="thinBorderedCard" mb={2.5} p={4} minH="300px">
            {aggregtedTabIndex === 'cover' && (
              <CustomInfiniteScroll
                isActiveIndex={1}
                dataLength={coverPhotoCount}
                next={coverPhotosFetchNextPage}
                hasMore={coverPhotosHasNextPage}
                isPhotos={hasCoverPhotos}
                photosArray={coverPhotos}
                setImageModel={setImageModel}
                setImageModelProps={setImageModelProps}
              />
            )}
            {aggregtedTabIndex === 'profile' && (
              <CustomInfiniteScroll
                isActiveIndex={1}
                dataLength={profilePhotoCount}
                next={profilePhotosFetchNextPage}
                hasMore={profilePhotosHasNextPage}
                isPhotos={hasProfilePhotos}
                photosArray={profilePhotos}
                setImageModel={setImageModel}
                setImageModelProps={setImageModelProps}
              />
            )}
            {aggregtedTabIndex === 'tagged' && (
              <CustomInfiniteScroll
                isActiveIndex={0}
                dataLength={photosOfYouCount}
                next={photosOfYouFetchNextPage}
                hasMore={photosOfYouHasNextPage}
                isPhotos={hasPhotosOfYou}
                photosArray={photosOfYou}
                setImageModel={setImageModel}
                setImageModelProps={setImageModelProps}
              />
            )}
            {aggregtedTabIndex === 'others' && (
              <CustomInfiniteScroll
                isActiveIndex={1}
                dataLength={yourPhotosCount}
                next={yourPhotosFetchNextPage}
                hasMore={yourPhotosHasNextPage}
                isPhotos={hasYourPhotos}
                photosArray={yourPhotos}
                setImageModel={setImageModel}
                setImageModelProps={setImageModelProps}
              />
            )}
          </Card>
        </>
      )}
      {audienceCreateDisc?.isOpen ? (
        <CreateAudiencePermissionModal
          {...audienceCreateDisc}
          audienceValue={audienceValue}
          setPermissionValue={(e) => setAudienceValue(e)}
          media={'media_photos'}
        />
      ) : (
        ''
      )}
      {activityDisc?.isOpen ? (
        <MyProfileCreatePostModal {...activityDisc} />
      ) : (
        ''
      )}
    </>
  );
};

const CustomInfiniteScroll = ({
  dataLength = 0,
  isActiveIndex,
  next,
  hasMore = false,
  isPhotos,
  photosArray,
  setImageModelProps,
  setImageModel,
}) => {
  const { t } = useTranslator();
  return (
    <>
      <InfiniteScroll
        className={styles.imgCont2}
        dataLength={dataLength}
        next={next}
        hasMore={!!hasMore}
        loader={
          <HStack p={4} justifyContent="center" w="100%">
            <Spinner />
          </HStack>
        }
        endMessage={
          <Text style={{ textAlign: 'center' }} py={3}>
            {isPhotos ? '' : t('profilePhotosVideos.noPhotos') || 'No photos to show'}
          </Text>
        }
      >
        {isPhotos &&
          photosArray.map((Img, i) =>
            Img?.media?.length > 1 ? (
              Img?.media?.map((MultiImg, multiIndex) => (
                <div className={isMobile?  styles.cardMobile2 :styles.card2} key={multiIndex}>
                  <img
                    src={MultiImg?.file}
                    alt="post image"
                    className={styles.img2}
                    onClick={() => {
                      const props = {
                        onClose: () => setImageModel(false),
                        postsData: photosArray,
                        fetchNext: next,
                        hasMore: hasMore,
                        postIndex: i,
                        postMediaIndex: multiIndex,
                      };
                      setImageModelProps(props);
                      setImageModel(true);
                    }}
                  />
                  <div className={styles.iconCont1}>
                    <PhotoActionsMenu
                      isPhotos={true}
                      isActiveIndex={isActiveIndex}
                      imageData={MultiImg}
                      selectedImgPost={Img}
                      selctedImage={MultiImg}
                    />
                  </div>
                </div>
              ))
            ) : (
              Img?.media?.[0]?.file?(


              <div className={isMobile?  styles.cardMobile2 :styles.card2}>
                <img
                  src={Img.media?.[0]?.file}
                  alt="post image"
                  className={styles.img2}
                  onClick={() => {
                    const props = {
                      onClose: () => setImageModel(false),
                      postsData: photosArray,
                      fetchNext: next,
                      hasMore: hasMore,
                      postIndex: i,
                      postMediaIndex: 0,
                    };
                    setImageModelProps(props);
                    setImageModel(true);
                  }}
                />
                <div className={styles.iconCont1}>
                  <PhotoActionsMenu
                    isPhotos={true}
                    isActiveIndex={isActiveIndex}
                    imageData={Img?.media?.[0]}
                    selectedImgPost={Img}
                  />
                </div>
              </div>
              ):""
            )
          )}
      </InfiniteScroll>
    </>
  );
};

const CustomInfiniteVideoScroll = ({
  dataLength = 0,
  next,
  hasMore,
  isActiveIndex,
  isVideos,
  videosArray,
  setReelModel,
  setReelModelProps,
}) => {
  const { t } = useTranslator();
  return (
    <>
      <InfiniteScroll
        className={styles.imgCont2}
        dataLength={dataLength}
        next={next}
        hasMore={!!hasMore}
        loader={
          <HStack p={4} justifyContent="center" w="100%">
            <Spinner />
          </HStack>
        }
        endMessage={
          <Text style={{ textAlign: 'center' }} py={3}>
            {isVideos ? '' : t('profilePhotosVideos.noVideos') || 'No Videos to show'}
          </Text>
        }
      >
        {isVideos &&
          videosArray.map((vid, i) =>
            vid.media?.length > 1 ? (
              vid?.media?.map((MultiVid, multiIndex) => (
                <div className={isMobile?  styles.cardMobile2 :styles.card2} key={multiIndex}>
                  <video
                    src={MultiVid?.file}
                    alt="post image"
                    className={styles.vid1}
                    onClick={() => {
                      const props = {
                        onClose: () => setReelModel(false),
                        postsData: videosArray,
                        fetchNext: next,
                        hasMore: hasMore,
                        postIndex: i,
                        postMediaIndex: multiIndex,
                      };
                      setReelModelProps(props);
                      setReelModel(true);
                    }}
                  />
                  <div className={styles.iconCont1}>
                    <PhotoActionsMenu
                      isPhotos={false}
                      isActiveIndex={isActiveIndex}
                      imageData={vid?.media?.[0]}
                      selectedImgPost={vid}
                    />
                  </div>
                  <div className={styles.videoLengthCont}>00:00</div>
                </div>
              ))
            ) : (
              <div className={isMobile?  styles.cardMobile2 :styles.card2}>
                <video
                  src={vid.media?.[0]?.file}
                  alt="post image"
                  className={styles.vid1}
                  onClick={() => {
                    const props = {
                      onClose: () => setReelModel(false),
                      postsData: videosArray,
                      fetchNext: next,
                      hasMore: hasMore,
                      postIndex: i,
                      postMediaIndex: 0,
                    };
                    setReelModelProps(props);
                    setReelModel(true);
                  }}
                />
                <div className={styles.iconCont1}>
                  <PhotoActionsMenu
                    isPhotos={false}
                    isActiveIndex={isActiveIndex}
                    imageData={vid?.media?.[0]}
                    selectedImgPost={vid}
                  />
                </div>
                <div className={styles.videoLengthCont}>00:00</div>
              </div>
            )
          )}
      </InfiniteScroll>
    </>
  );
};
